import ButtonBase from '@mui/material/ButtonBase';
import clsx from 'clsx';
import { ReactComponent as PrevIcon } from 'assets/images/arrow-prev-blue.svg';
import { ReactComponent as NextIcon } from 'assets/images/arrow-next-blue.svg';

import styles from './styles.module.scss';

type InputProps = {
  arrowDirection: 'left' | 'right';
  className?: string;
  children: string;
  onClick: () => void;
};

export const NavButton = ({
  arrowDirection,
  className,
  children,
  onClick,
}: InputProps) => {
  return (
    <ButtonBase
      onClick={onClick}
      classes={{
        root: clsx(styles.root, className),
      }}
    >
      {arrowDirection === 'left' && <PrevIcon />}
      <span>{children}</span>
      {arrowDirection === 'right' && <NextIcon />}
    </ButtonBase>
  );
};
